import React from "react";
import "./Navbar.css";
import logo from "../../assets/Navbar/anupreetha-logo-violet.svg";
import HeroSection from "../HeroSection/HeroSection";
import Sticker from "../Sticker/Sticker";

const Navbar = () => {
  return (
    <section className="navAndHerosection" id="home">
      <nav className="navbar" id="homepage">
        <div className="navbarcontainer">
          <a href="/" className="anchorlink" ><img src={logo} alt="logo" className="navbarlogo" /></a>
          <ul className="navbarItems">
            <a href="#work" className="anchorlink">
              <li className="navbarItemList">
                <span>work</span>
              </li>
            </a>
            <a href="#about" className="anchorlink">
              <li className="navbarItemList">
                <span>about</span>
              </li>
            </a>
            <a href="#contact" className="anchorlink">
              <li className="navbarItemList">
                <span>contact</span>
              </li>
            </a>
            <a href="https://drive.google.com/file/d/1nyEHEj1C8fQ2_AHZJ3cACaP9WGp-CXBk/view?usp=sharing" target="_blank" rel="noreferrer" className="anchorlink">
              <li className="navbarItemList">
                <span>resume</span>
              </li>
            </a>
          </ul>
        </div>
      </nav>

      <HeroSection />
      <Sticker />
      
    </section>
  );
};

export default Navbar;
